import { HotelConfiguration } from '../../../hooks/useHotelConfig/useHotelConfig';
import apiCall from '../../apiCall/apiCall';

class Kiosk {
  static show(): Promise<HotelConfiguration> {
    return apiCall('GET', '') as Promise<HotelConfiguration>;
  }
}

export default Kiosk;
